import type { SupabaseClient } from '@supabase/supabase-js'
import type { RefreshSession } from '@/modules/auth/use-cases'

export class SupabaseRefreshSessionRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: RefreshSession = async () => {
    const { error } = await this.client.auth.refreshSession()
    if (error) throw error
  }
}
